import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import UserDataService from "../../../services/UserService";

const UsersTable = () => {
  const [users, setUser] = useState([]);
  const [usersPin, setUserPin] = useState([]);

  useEffect(() => {
    retrieveUsers();
  }, []);

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );

  const retrieveUsers = () => {
    if (JSON.parse(localStorage.getItem("loc")).id >= 0) {
      UserDataService.getAllFired(loc)
        .then((response) => {
          setUser(response.data);
        })
        .catch((e) => {
          setErrorMessages(["Cannot load user data"]);
          setIserror(true);
        });
    } else if (JSON.parse(localStorage.getItem("loc")).id === "all") {
      UserDataService.adminAllFired()
        .then((response) => {
          setUser(response.data);
        })
        .catch((e) => {
          setErrorMessages(["Cannot load user data"]);
          setIserror(true);
        });
    }
  };

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const FIRED_DATE_FORMAT = "DD/MMM/YYYY";

  return (
    <div>
      <MaterialTable
        title="Изключени потребители"
        columns={[
          // { title: 'Id', field: 'id' },
          { title: "Име", field: "name", defaultSort: "asc" },
          { title: "Имейл", field: "email" },
          {
            title: "Локация",
            field: "loc_name",
            editable: "never",
            type: "date",
          },
          {
            title: "Вид потребител",
            field: "sub_loc_name",
            editable: "never",
            type: "date",
          },
          { title: "No.", field: "sap" },
        ]}
        data={users}
        style={{
          borderRadius: "0",
          boxShadow: "none",
        }}
        actions={[
          {
            icon: "refresh",
            tooltip: "Refresh",
            isFreeAction: true,
            onClick: retrieveUsers,
          },
        ]}
        options={{
          loadingType: "linear",
          pageSize: 10,
          maxBodyHeight: "65vh",
          showTitle: true,
          sorting: true,
          actionsColumnIndex: -1,
          exportButton: { csv: true, pdf: false },
          filtering: true,
          pageSizeOptions: [5, 10, 20, 50, 100],
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} of {count}",
          },
          header: {
            actions: "Actions",
          },
          body: {
            emptyDataSourceMessage: "Няма изключени потребители.",
            filterRow: {
              filterTooltip: "Filter",
            },
            editRow: {
              deleteText: "Сигурни ли сте че искате да изтриете потребителя?",
            },
          },
        }}
      />
    </div>
  );
};

export default UsersTable;
